var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-plans-list mt-5"},_vm._l((_vm.filteredPlans),function(plan){return _c('v-slide-x-transition',{key:plan._id},[_c('CardListPlanosAcao',{staticClass:"mb-2",attrs:{"action-plan":plan}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }